module.exports = __webpack_public_path__ + "img/basket-fill.1cb30b97.svg";